import { render, staticRenderFns } from "./nav-menu.vue?vue&type=template&id=3bfd114b"
import script from "./nav-menu.ts?vue&type=script&lang=js&external"
export * from "./nav-menu.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports